export default {
  path: '/common',
  name: 'Common',
  hidden: true,
  redirect: '/common/button',
  component: () => import(/* webpackChunkName: "common" */ '@/components-v3/layout'),
  children: [
    {
      path: "button",
      name: 'Button',
      text: 'Button',
      component: () => import(/* webpackChunkName: "common" */ '@/components-v3/packages/button/demo')
    },
    {
      path: "image-picker",
      name: "ImagePicker",
      text: "ImagePicker",
      component: () => import('@/components-v3/packages/image-picker/demo')
    },
    {
      path: "pagination",
      name: "pagination",
      text: "pagination",
      component: () => import('@/components-v3/packages/pagination/demo')
    },
    {
      path: "header",
      name: "header",
      text: "header",
      component: () => import('@/components-v3/packages/header/demo')
    },
    {
      path: "tabs",
      name: "tabs",
      text: "tabs",
      component: () => import('@/components-v3/packages/tabs/demo')
    },

  ]
}